var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-badge',{staticClass:"text-capitalize",attrs:{"variant":_vm.statusList[_vm.status].color}},[_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.statusValue))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }